export default "__VITE_ASSET__C_M_$FWl__"